import App from "../app/App";
import Login from "../pages/login/Login";
import Signup from "../pages/signup/Signup";
import PasswordRecovery from "../pages/password-recovery/PasswordRecovery";
import PasswordReset from "../pages/password-reset/PasswordReset";
import PasswordChange from "../pages/password-change/PasswordChange";
import CompleteSubscription from "../pages/complete-subscription/CompleteSubscription";
import RedirectAdmin from "./RedirectAdmin";
import Admin from "../pages/admin/Admin";
import EmailVarification from "../pages/confirmemail/EmailVarification";
import Subscriber from "../pages/subscription/subscriber";
import Playlists from "../pages/playlists/Playlists";
import PatientPlaylists from "../pages/patientplaylist/PatientView";
import CategoryVideos from "../pages/patientplaylist/categoryVideos/CategoryVideos";
import VideoChooser from "../pages/playlists/form/videos/video-chooser/VideoChooser";
import Plannings from "../pages/plannings/Plannings";
import PreviewFlyers from "../pages/admin/Flyers/PreviewFlyers";
import Quiz from "../pages/quiz/Quiz";
import AddPlaylist from "../pages/playlists/add/AddPlaylist";
import UpdatePlaylist from "../pages/playlists/update/UpdatePlaylist";
import UserProfile from "../pages/userprofile/UserProfile";
import UserInvoices from "../pages/userinvoices/UserInvoices";
import VideosView from "../pages/patientplaylist/VideosView";
import Err from "../pages/patientplaylist/404Page/404Page";
import welcome from "../pages/admin/Welcome";
import tutoriel from "../pages/tutoriel/Tutoriel";
import ChartJs from "../pages/admin/stats/stats";
import InfoDoctor from "../pages/patientplaylist/InfoDoctor/InfoDoctor";

const routes = [
  {
    component: App,
    routes: [
      {
        path: "/tutoriel",
        exact: true,
        component: tutoriel,
      },
      {
        path: "/login",
        exact: true,
        component: Login,
      },
      {
        path: "/welcome",
        exact: true,
        component: welcome,
      },
      {
        path: "/signup/",
        exact: true,
        component: Signup,
      },
      {
        path: "/signup/:plan/:email",
        exact: true,
        component: Signup,
      },
      {
        path: "/password-recovery",
        exact: true,
        component: PasswordRecovery,
      },
      {
        path: "/email-varification",
        exact: true,
        component: EmailVarification,
      },
      {
        path: "/password-reset",
        exact: true,
        component: PasswordReset,
      },
      {
        path: "/complete-subscription",
        exact: true,
        component: CompleteSubscription,
      },
      {
        path: "/patient-playlists/:categorySlug",
        exact: true,
        component: CategoryVideos,
      },
      {
        path: "/patient-playlists",
        exact: true,
        component: PatientPlaylists,
      },
      {
        path: "/info-doctor",
        exact: true,
        component: InfoDoctor,
      },
      // Get videos
      {
        path: "/videos-patients",
        exact: true,
        component: VideosView,
      },
      {
        path: "/404",
        exact: true,
        component: Err,
      },
      {
        component: Admin,
        routes: [
          {
            path: "/",
            exact: true,
            component: RedirectAdmin,
          },
          {
            path: "/updateprofile",
            exact: true,
            component: UserProfile,
          },
          {
            path: "/stats",
            exact: true,
            component: ChartJs,
          },
          {
            path: "/flyers",
            exact: true,
            component: PreviewFlyers,
          },
          {
            path: "/invoices",
            exact: true,
            component: UserInvoices,
          },
          {
            path: "/password-change",
            exact: true,
            component: PasswordChange,
          },
          {
            path: "/subscriber",
            exact: true,
            component: Subscriber,
          },
          {
            path: "/playlists",
            exact: true,
            component: Playlists,
          },
          {
            path: "/playlists/add",
            exact: true,
            component: AddPlaylist,
          },
          {
            path: "/playlists/update/:id/:wall",
            exact: true,
            component: UpdatePlaylist,
            VideoChooser,
          },
          {
            path: "/plannings",
            exact: true,
            component: Plannings,
          },
          {
            path: "/quiz",
            exact: true,
            component: Quiz,
          },
        ],
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js